import { RouteConfig } from "vue-router";
import Layout from '@/layout/index.vue';

const institutionResource: RouteConfig[] = [
  {
    path: '/institution-resource',
    component: Layout,
    meta: {
      roles: ['resource']
    },
    children: [
      {
        path: 'resource-management',
        name: 'resourceManagement',
        meta: {
          icon: 'resource-icon',
          title: 'resourceManagement',
          roles: ['resource']
        },
        component: () => import(/* webpackChunkName: "common-iframe" */ '@/views/institution-resource/ResourceManagement.vue'),
      },
      {
        path: 'application-fee/:id',
        name: 'applicationFee',
        meta: {
          hidden: true,
          title: 'applicationFee',
          activeMenu: '/resource-management',
          roles: ['resource']
        },
        component: () => import('@/views/institution-resource/InstitutionInfo.vue'),
      },
      {
        path: 'language-req/:id',
        name: 'languageReq',
        meta: {
          hidden: true,
          title: 'languageReq',
          activeMenu: '/resource-management',
          roles: ['resource']
        },
        component: () => import('@/views/institution-resource/InstitutionInfo.vue'),
      },
    ]
  }
]
export default institutionResource
